import { FONT_FAMILY } from "../../common/sharedFunctions";

const TableStyle = (settings) => {
    return {
        editable: {
            backgroundColor: '#ffffff',
            fontSize: "0.8em",
            fontWeight: "bold",
            fontFamily: FONT_FAMILY 
        },
        pageSize: 10,
        pageSizeOptions: [10, 15, 20],
        headerStyle: {
            color: '#374151',
            position: "sticky",
            top: "0px",
            backgroundColor: '#f8fafc',
            textAlign: "center",
            fontSize: "0.72em",
            fontWeight: "700",
            textTransform: "uppercase",
            letterSpacing: "0.06em",
            borderBottom: '2px solid #e5e7eb',
            fontFamily: FONT_FAMILY,
            padding: '14px 16px',
        },
        cellStyle: {
            borderBottom: '1px solid #f3f4f6',
            textAlign: "center",
            padding: '14px 16px',
            fontSize: '0.85em',
            color: '#4b5563',
            fontFamily: FONT_FAMILY,
        },
        actionsColumnIndex: -1,
        searchFieldStyle: {
            fontFamily: FONT_FAMILY,
            fontSize: '0.9em',
        },
        rowStyle: (rowData, index) => ({
            backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc',
            transition: 'background-color 0.15s ease',
        }),
    }
};

export default TableStyle;
